import { Logo } from '@/components/ui/logo'
import { Progress } from '@/components/ui/progress'
import { useRouterState } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export function LoadingScreen() {
  const isLoading = useRouterState({ select: (s) => s.status === 'pending' })
  const [progress, setProgress] = useState(10)

  useEffect(() => {
    if (isLoading) {
      setProgress(10)
      const interval = setInterval(() => {
        setProgress((prev) => (prev < 90 ? prev + 10 : prev))
      }, 100)
      return () => clearInterval(interval)
    } else {
      setProgress(100)
      setTimeout(() => setProgress(0), 100)
    }
  }, [isLoading])

  return (
    <section
      className={
        'fixed inset-0 flex flex-col items-center justify-center gap-3.5'
      }
    >
      <Logo />
      <Progress value={progress} className={'h-1 max-w-[199px]'} />
    </section>
  )
}
